import defaultCode from "./defaultCode";
import lesson from "./lesson";
import test from "./test";

export default {
    name: "Depth-First Search",
    defaultCode,
    lesson,
    test,
    difficulty: 1,
};
